<bb-transaction-signing-widget class="bn-transaction-signing-widget">
  <ng-template bbTransactionSigningInterfaceCustomizable
               let-hostRef>
    <bb-modal-ui [isOpen]="true"
                 [modalOptions]="modalOptions">
      <bb-modal-header-ui data-role="ts-modal">
        <ng-template bbCustomModalHeader>
          <bb-header-ui class="bn-transaction-signing-widget___modal-header"
                        headingType="h2"
                        i18n-heading="Transaction signing modal title for initiate-payment@@bb-transaction-signing-header.initiate-payment.title"
                        heading="Verification code">
          </bb-header-ui>

        </ng-template>
      </bb-modal-header-ui>
      <div class="mx-4">
        <hr>
      </div>

      <bb-modal-body-ui>
        <ng-template bbCustomModalBody>
          <bb-transaction-signing-action-pending *ngIf="hostRef.isPending"></bb-transaction-signing-action-pending>
          <ng-container *ngIf="!hostRef.isPending">
            <bb-transaction-signing-error *ngIf="hostRef.challengeError"
                                          [error]="hostRef.challengeError"
                                          (close)="hostRef.failure.emit($event)">
            </bb-transaction-signing-error>
            <bb-transaction-signing-sms-otp *ngIf="hostRef.isChallengeType('sms-otp-auth')"
                                            [data]="hostRef.challengeData"
                                            [previousData]="hostRef.previousChallengeData"
                                            [error]="hostRef.error"
                                            (complete)="hostRef.post.emit($event)"
                                            (cancel)="hostRef.post.emit({ responseType: 'confirmation-abort' })"
                                            (acceptError)="hostRef.failure.emit($event)"
                                            (resend)="hostRef.post.emit({ responseType: 'otp-resend' })">
            </bb-transaction-signing-sms-otp>
            {{validatingData(hostRef)}}
            <bn-otp-web *ngIf="hostRef.isChallengeType('otp-custom-select-send-method')"
                        [data]="hostRef.challengeData.data"
                        (continue)="hostRef.post.emit($event)"
                        (cancel)="hostRef.post.emit($event)"
            ></bn-otp-web>
            <bn-otp-verification-code *ngIf="hostRef.isChallengeType('otp-custom-validate')"
                                      [data]="hostRef.challengeData.data"
                                      (complete)="hostRef.post.emit($event)"
                                      (resend)="hostRef.post.emit($event)"
                                      (cancel)="hostRef.post.emit($event)">
            </bn-otp-verification-code>
            <bn-otp-error *ngIf="hostRef.isChallengeType('otp-custom-action-error')"></bn-otp-error>
          </ng-container>
        </ng-template>
      </bb-modal-body-ui>
    </bb-modal-ui>
  </ng-template>
</bb-transaction-signing-widget>
